import { useFormContext } from 'react-hook-form';

import { SessionType } from 'features/sessions/config/types';
import { useSessionsQueryActions } from 'features/sessions/hooks/useSessionsQueryActions';

import { showErrorToast, showSuccessToast } from 'shared/components/Toast';

export const useNextSessionScheduleMutateOptions = (sessionId: string) => {
  const { reset, watch, getValues } = useFormContext();

  const nextSessionAppointment = watch('nextSessionAppointment');

  const { updateSession } = useSessionsQueryActions();

  return {
    onSuccess: (session: SessionType) => {
      const formSession = getValues();

      reset({
        ...formSession,
        nextSessionAppointment: {
          ...nextSessionAppointment,
          startAt: session.startAt,
          endAt: session.endAt,
          attendance: session.attendance,
          coachingSessionId: session.coachingSessionId,
        },
      });

      updateSession(sessionId, {
        // @ts-ignore
        nextSessionAppointment: {
          startAt: session.startAt!,
          endAt: session.endAt!,
          attendance: session.attendance,
        },
      });

      showSuccessToast('Next session scheduled successfully');
    },
    onError: () => {
      showErrorToast(
        'Failed to schedule next session. Please try again later.'
      );
    },
  };
};
